import { ISPFieldConfig, ISPValidator } from '../model';

/**
 * Add validator to config
 *
 * @param config
 * @param validator
 */
export function addValidator(
  config: ISPFieldConfig,
  validator: ISPValidator,
): void {
  if (!Array.isArray(config.validators?.validation)) {
    config.validators = {
      ...config.validators,
      validation: [],
    };
  }
  config.validators?.validation.push(validator);
}
